import React, { Component } from 'react';
import PropTypes from 'prop-types'
import classnames from 'classnames';
import {Image} from 'bloomer'
import {head, is, compose, take, map, join} from 'ramda'

export default class Avatar extends Component {
  static propTypes = {
    name: PropTypes.string,
    url: PropTypes.string,
    style: PropTypes.object,
    size: PropTypes.string,
    inverted: PropTypes.bool
  };

  renderWithImage = () => {
    return (
      <Image
        src={this.props.url}
        className={`common-avatar-image ${this.props.size}`}/>
    )
  }

  renderWithInitials = () => {
    const name = (this.props.name) ? this.props.name : 'Default'
    const hasWhiteSpace = (name) ? name.match(/\s/ig) !== -1 : false

    let initials = (hasWhiteSpace) ? name.split(" ") : name
    let _name = (is(Array, initials))
      ? compose(join(''), take(2), map(i => head(i)))(initials)
      : head(name)

    return (
      <span className={classnames(`common-avatar-initial`,
        {
          large: this.props.size === 'large',
          medium: this.props.size === 'medium',
          small: this.props.size === 'small',
          smaller: this.props.size === 'smaller',
          smallest: this.props.size === 'smallest',
          inverted: this.props.inverted
        }
      )}>
        {_name.toUpperCase()}
      </span>
    )
  }

  render() {
    return (
      <div
        className={
          classnames('common-avatar', this.props.classname)
        }
        style={this.props.style}>
        {this.props.url
          ? this.renderWithImage()
          : this.renderWithInitials()
        }
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/features/common/Avatar.js